export const bodyLabel = {
  notApplicable: "Not Applicable",
  //unknown: "Unknown",
  head: "Head",
  face: "Face",
  neck: "Neck",
  shoulderLeft: "Shoulder-Left",
  shoulderRight: "Shoulder-Right",
  armLeft: "Arm-Left",
  forearmLeft: "Forearm-Left",
  armRight: "Arm-Right",
  forearmRight: "Forearm-Right",
  chestLeft: "Chest-Left",
  chestRight: "Chest-Right",
  bellyLeft: "Belly-Left",
  ribsLeft: "Ribs-Left",
  bellyRight: "Belly-Right",
  belly: "Belly",
  ribsRight: "Ribs-Right",
  thighLeft: "Thigh-Left",
  innerthighLeft: "Innerthigh-Left",
  feetLeft: "Feet-Left",
  calfLeft: "Calf-Left",
  kneeLeft: "Knee-Left",
  thighRight: "Thigh-Right",
  genitalia: "Genitalia",
  innerthighRight: "Innerthigh-Right",
  rightFeet: "Right-Feet",
  calfRight: "Calf-Right",
  kneeRight: "Knee-Right",
  elbowRight: "Elbow-Right",
  handRight: "Hand-Right",
  elbowLeft: "Elbow-Left",
  handsLeft: "Hands-Left",
  armbackLeft: "Armback-Left",
  legLeft: "Leg-Left",
  buttock: "Buttock",
  loin: "Loin",
  column: "Column",
  headBack: "Head-Back",
  nape: "Nape",
  armbackRight: "Armback-Right",
  legRight: "Leg-Right",
  backRight: "Back-Right",
  claviculeRight: "Clavicule-Right",
  backLeft: "Back-Left",
  claviculeLeft: "Clavicule-Left",
};

export const bodyValue = {
  head: 0,
  face: 0,
  neck: 0,
  shoulderLeft: 0,
  shoulderRight: 0,
  armLeft: 0,
  forearmLeft: 0,
  armRight: 0,
  forearmRight: 0,
  chestLeft: 0,
  chestRight: 0,
  bellyLeft: 0,
  ribsLeft: 0,
  bellyRight: 0,
  belly: 0,
  ribsRight: 0,
  thighLeft: 0,
  innerthighLeft: 0,
  feetLeft: 0,
  calfLeft: 0,
  kneeLeft: 0,
  thighRight: 0,
  genitalia: 0,
  innerthighRight: 0,
  rightFeet: 0,
  calfRight: 0,
  kneeRight: 0,
  elbowRight: 0,
  handRight: 0,
  elbowLeft: 0,
  handsLeft: 0,
  armbackLeft: 0,
  legLeft: 0,
  buttock: 0,
  loin: 0,
  column: 0,
  headBack: 0,
  nape: 0,
  armbackRight: 0,
  legRight: 0,
  backRight: 0,
  claviculeRight: 0,
  backLeft: 0,
  claviculeLeft: 0,
};
